import initialState from './deviceDetailInitialState';

const mutations = {
  DEVICE_DETAIL_CHANGE_VALUE: (state, payload) => {
    const {
      key,
      value,
    } = payload;
    state[key] = value;
  },
  DEVICE_DETAIL_CHANGE_VALUES: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
  DEVICE_DETAIL_SET_QUERY: (state, payload) => {
    const {
      uid,
      startTime,
      endTime,
      activeTab,
    } = payload;
    state.currentUid = uid;
    state.startTime = startTime;
    state.endTime = endTime;
    state.activeTab = activeTab;
  },
  DEVICE_DETAIL_SET_DEVICE: (state, payload) => {
    const {
      currentUid,
      hub,
      hubStatus,
      hvac,
      firmware,
      sensors,
      customer,
      lastSensorReadings,
      graphData,
      deviceStatus,
      deviceConfig,
      rawPayload,
      rawBatch,
      log,
      moreInfo,
    } = payload;
    state.currentUid = currentUid;
    state.customer = customer;
    state.lastSensorReadings = lastSensorReadings;
    state.log = log;
    state.moreInfo = moreInfo;
    state.hub = hub;
    state.hubStatus = hubStatus;
    state.hvac = hvac;
    state.firmware = firmware;
    state.sensors = sensors;
    state.graphData = graphData;
    state.deviceStatus = deviceStatus;
    state.deviceConfig = deviceConfig;
    state.rawPayload = rawPayload;
    state.rawBatch = rawBatch;
    state.loadingGraphData = false;
  },
  DEVICE_DETAIL_SET_GRAPH_DATA: (state, payload) => {
    const {
      cycleData,
      cyclePayloads,
      startOfDay,
      endOfDay,
      startTime,
      endTime,
      allSupplySerialCycles,
      selectedSupplySerial,
      weatherData,
      zoneMapping,
      devices,
    } = payload;
    state.cycleData = cycleData;
    state.cyclePayloads = cyclePayloads;
    state.startOfDay = startOfDay;
    state.endOfDay = endOfDay;
    state.allSupplySerialCycles = allSupplySerialCycles;
    state.selectedSupplySerial = selectedSupplySerial;
    state.startTime = startTime;
    state.endTime = endTime;
    state.weatherData = weatherData;
    state.zoneMapping = zoneMapping;
    state.devices = devices;
  },
  DEVICE_DETAIL_RESET_STATE: (state) => {
    Object.assign(state, initialState());
  },
  ADMIN_LOGOUT: (state) => {
    Object.assign(state, initialState());
  },
};

export default mutations;
